import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import styled from "styled-components/macro";

import { faAsterisk, faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import { useGetPaymentTypeVerbiage } from "Payments/PaymentPage/Shared/useGetPaymentTypeVerbiage";

export default function ExistingRecurringPayments() {
  const hasExistingRecurringGiftForFund =
    window?.data?.paymentPageData?.user?.hasExistingRecurringGiftForFund;
  const fundName = window?.data?.paymentPageData?.fund?.description;

  const { noun } = useGetPaymentTypeVerbiage();

  if (!hasExistingRecurringGiftForFund) return null;

  return (
    <Wrapper>
      {/* <FontAwesomeIcon icon={faInfoCircle} style={{ marginTop: "2px" }} /> */}
      <div>
        You already have a recurring {noun} for {fundName}.
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 12px;
  font-style: italic;
  /* margin-left: 15px; */
  margin-left: 28px;
  margin-top: 8px;

  @media screen and (max-width: 480px) {
    margin-left: 0;
  }
`;
